import { createConfirmation } from 'react-confirm'
import MyDialog, { MyDialogProps } from './MyDialog'

const confirm = createConfirmation(MyDialog)

export function confirmDialog({
  title, 
  cancelText,
  proccedText,
  type,
  content
}: MyDialogProps) {
  return confirm({ 
    title, 
    cancelText,
    proccedText,
    type,
    content
  })
}
